import { defineComponent as _defineComponent } from 'vue'
import {useRoute} from 'vue-router';
import {onMounted} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Forwarding',
  setup(__props, { expose }) {
  expose();

const router = useRoute();

onMounted(() => {
    const url = router.query.url;
    if (url) {
        window.location.href = url as string;
    }
});

const __returned__ = { router, useRoute, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})